import type { MapSearchInput } from '@/shared/utils/queryUtils'

export const userLimitsTableFields: MapSearchInput['path'] = {
    name: ['userId'],
    number: ['amount']
}
